import { AfterViewChecked, Component, Input } from '@angular/core';
import { Post } from "../../../app/app.interfaces";

@Component({
  selector: 'post-list',
  templateUrl: 'post-list.html'
})

export class PostList implements AfterViewChecked {

  @Input() posts: Post[];

  ngAfterViewChecked(): void {
    let timeout = 40;
    let newCards = document.querySelectorAll('post-card:not(.loaded)');
    for (let i = 0, newCard; newCard = newCards[i]; i++) {
      setTimeout(()=> {
        newCard.classList.add('loaded');
      },50);
      // setTimeout(()=>{
      //   newCard.classList.add('loaded');
      // },(timeout*i));
    }
    
    
  }
}




// WEBPACK FOOTER //
// ./src/partials/post/post-list/post-list.ts